export default {"src":"/_next/static/media/dobrozem-not-found.20a3b13a.svg","height":322,"width":436,"blurWidth":0,"blurHeight":0};